import { Component, ChangeDetectionStrategy, ViewContainerRef } from '@angular/core';
import { FeedImageModalParams } from '@shared/components/feed-image-modal/feed-image-modal.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ModalShape, ModalsService } from '@shared/modals/modals.service';
import { DeephubImagesDataService } from 'src/generated-sources';
import { DeephubImageClassificationReportImageFeedModalComponent } from '@features/deephub/image-classification/report/image-feed-modal/deephub-image-classification-report-image-feed-modal.component';
import { DeephubImageClassificationReportDataFetcherService } from '../services/deephub-image-classification-report-data-fetcher.service';

@UntilDestroy()
@Component({
  selector: 'deephub-image-classification-report-image-feed',
  templateUrl: './deephub-image-classification-report-image-feed.component.html',
  styleUrls: ['../../../computer-vision/report/image-feed/deephub-compute-version-report-image-feed.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeephubImageClassificationReportImageFeedComponent {
    constructor(
        public dataFetcher: DeephubImageClassificationReportDataFetcherService,
        public viewContainerRef: ViewContainerRef,
        public modalsService: ModalsService
    ) {}

    openModal({ imageId }: FeedImageModalParams) {
        this.modalsService
            .open(DeephubImageClassificationReportImageFeedModalComponent, {
                imageId
             }, ModalShape.FULL, this.viewContainerRef)
            .then(() => {}, () => {});
    }

    public get SortBy() {
        return DeephubImagesDataService.SortBy;
    }

    setSorting(filter: Partial<DeephubImagesDataService.ImageClassificationPredictedFilter>) {
        filter.ascending = !filter.ascending
        this.dataFetcher.setFilteredPair(filter);
    }
}
